import { NextPage } from "next";
import { Section } from "components/aud/base/Section";
import Head from "next/head";
import { PageTitle } from "components/aud/ui/PageTitle";
import css from "./index.module.scss";
import { useListProfessionalsQuery } from "~/hooks/rtk-query-api";
import { getInitialPageProps } from "~/store";
import { loadProfessionalsPageData } from "~/components/links/ProfessionalsPageLink";
import { ProfessionalCard } from "~/components/aud/ui/ProfessionalCard";
import { useEffect, useState } from "react";
import { User } from "~/generated/rtk-query/nowdo-live-api.generated";

const useInfinityListProfessionalsQuery = () => {
  const [cursor, setCursor] = useState<string | null>(null);
  const professionalsQuery = useListProfessionalsQuery({
    sort: "archive",
    ...(cursor ? { cursor } : {}),
  });
  const [professionals, setProfessionals] = useState<User[]>(professionalsQuery.data?.professionals ?? []);

  useEffect(() => {
    const _professionals = professionalsQuery.data?.professionals;
    if (professionalsQuery.isSuccess && _professionals && _professionals !== professionals) {
      setProfessionals((v) => [...v, ..._professionals]);
    }
  }, [professionalsQuery.data]);

  useEffect(() => {
    if (!professionalsQuery.data?.cursor) {
      return;
    }
    const handler = () => {
      const margin = 300;
      if (professionalsQuery.data && document.body.clientHeight - window.innerHeight <= window.pageYOffset + margin) {
        setCursor(professionalsQuery.data.cursor);
      }
    };
    window.addEventListener("scroll", handler);
    return () => window.removeEventListener("scroll", handler);
  }, [professionalsQuery.data?.cursor]);

  return professionals;
};

const ProfessionalsPage: NextPage = () => {
  const professionals = useInfinityListProfessionalsQuery();

  return (
    <main>
      <Head>
        <title>プロフェッショナル一覧</title>
      </Head>
      <Section>
        <div className={css.maxWidth}>
          <PageTitle title="Professionals" sub="プロフェッショナル一覧" />
          <div className={css.professionalsWrapper}>
            <div className={css.professionals}>
              {professionals.map((professional) => (
                <ProfessionalCard
                  key={professional.id}
                  professional={professional}
                  // 画像が正方形じゃない関係で、画像サイズが幅256pxで取得されるので、Qualityを下げます
                  // 120 / 256 * 80 = 37.5
                  imageSize={120}
                  imageQuality={37}
                />
              ))}
            </div>
          </div>
        </div>
      </Section>
    </main>
  );
};

ProfessionalsPage.getInitialProps = getInitialPageProps((store) => async () => {
  await loadProfessionalsPageData(store);
  return {};
});

export default ProfessionalsPage;
